import React, { useState, useEffect } from "react";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import clsx from "clsx";
import PublishIcon from "@material-ui/icons/Publish";
import { Box, Grid } from "@material-ui/core";
import { BreadcrumbPage } from "../../shared";
import CustomerContractDetails from "./CustomerContractDetails";
import { CommonCss } from "../../services/CommonCss";
import { useHistory } from "react-router-dom";
import { getCookie } from "../../services/Cookies";
import { getRequest } from "../../services/ApiServices";
import { ToastError } from "../../services/ToastMsg";
import { LOADING } from '../../action';
import { useDispatch} from 'react-redux';
import shipDatObj from './ShipData';
const useStyles = makeStyles((theme) => ({
  infoBox: {
    boxShadow: "3px 3px 6px #00000029",
    borderRadius: "10px",
  },
  text1: {
    fontSize: "18px",
    letterSpacing: "0.54px",
    color: "#1A1A31",
  },
  text2: {
    fontSize: "18px",
    color: "#5A5B5E",
  },
  
  
}));
export default function ShipDetails(props) {
  const history = useHistory();
  const classes = useStyles();
  const commonClasses = CommonCss();
  
  //const BreadcrumbTitle = "Atlanta 1 (IMO9563706)";
  // const [shipList, setShipList] = useState([]);
  const [dataDetailsState, setDataDetailsState] = useState(props.location.data?props.location.data:[]);
  const [dataOfEquipement, setDataOfEquipement] = useState({});
  const dispatch = useDispatch();
  const sekletedVesselKey = 5125648;
  const BreadcrumbList = [
    { name: "Ship Page", url: "" },
    { name: "Ship Details", url: "/dashboard/assets" },
    { name: dataDetailsState.currentVesselName, url: "/dashboard/assets" },
    { name: "Equipment", url: "/dashboard/assets" },
  ];
  ////console.log(props, "dshppp")
  useEffect(() => {
    if(props.location.data){
      getEquipementShipData(props.location.data.vesselKey);
    }
    if(!props.location.data){
      history.push({
        pathname: `/dashboard/assets`
      })
    }
  }, [])
  

  const getEquipementShipData = (vesselKey) => {
    dispatch({type:LOADING, payload: true});
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Ship/Equipment/${vesselKey}`;
    getRequest(url)
    .then((res) => {
      ////console.log(res);
      if (res.data.length) {
        setDataOfEquipement(res.data);
      } else {
        setDataOfEquipement([]);
      }
      dispatch({type:LOADING, payload: false});
    })
    .catch((error) => {
      dispatch({type:LOADING, payload: false});
      // setDataOfEquipement(shipDatObj);
      setDataOfEquipement([]);

      ////console.log(error);
      // ToastError(error.response.data.message);
    });
  }
  

  return (
    <div>
      <Box px={2} py={3}>
        <Grid container  spacing={3}>
          <Grid item  xs={12} >
            <BreadcrumbPage className="BreadcrumbList" rows={BreadcrumbList} title= {dataDetailsState.currentVesselName+'-'+dataDetailsState.imono} />
          </Grid>
      {
        Object.keys(dataDetailsState).length ? (
          <React.Fragment>
            <Grid item xs={12} md={12} alignItems="stretch">
            <Box
              display="flex"
              bgcolor="#fff"
              px={4}
              py={2}
              className={clsx(classes.infoBox, classes.text1)}
            >
              <Box width={0.33}>
                <Box component="p" fontWeight="500">
                  Information :
                </Box>
                <Box component="p">
                  <Box component="span" fontWeight="500">
                    Ship Name: {dataDetailsState.currentVesselName}
                  </Box>
                  {/* {"Atlaanta"} */}
                </Box>
                <Box component="p">
                  <Box component="span" fontWeight="500">
                    IMO:{dataDetailsState.imono}
                  </Box>{" "}
                 
                </Box>
                <Box component="p">
                  <Box component="span" fontWeight="500">
                    Object No:
                  </Box>{" "}
                  {/* V2FLB */}
                </Box>
                <Box component="p">
                  <Box component="span" fontWeight="500">
                    Flag:
                  </Box>{" "}
                  {/* BBC Chartering & Logistic GmbH */}
                </Box>
                <Box component="p">
                  <Box component="span" fontWeight="500">
                    Operator:
                  </Box>{" "}
                  {/* BBC Chartering & Logistic GmbH */}
                </Box>
              </Box>
              <Box width={0.33}>
                <Box component="p" py={1}></Box>
                <Box component="p">
                  <Box component="span" fontWeight="500">
                    Ship Owner:
                  </Box>{" "}
                  {/* Atlaanta */}
                </Box>
                <Box component="p">
                  <Box component="span" fontWeight="500">
                    DWT Range:
                  </Box>{" "}
                 {/*  9563706 */}
                </Box>
                <Box component="p">
                  <Box component="span" fontWeight="500">
                    Year Built:
                  </Box>{" "}
                  {/* V2FLB */}
                </Box>
                <Box component="p">
                  <Box component="span" fontWeight="500">
                    Operator:
                  </Box>{" "}
                  {/* BBC Chartering & Logistic GmbH */}
                </Box>
                <Box component="p">
                  <Box component="span" fontWeight="500">
                    Shipyard:
                  </Box>{" "}
                  {/* BBC Chartering & Logistic GmbH */}
                </Box>
              </Box>
              <Box width={0.33}>
                <Box component="p" py={1}></Box>
                <Box component="p">
                  <Box component="span" fontWeight="500">
                    Ship Manager:
                  </Box>{" "}
                  {/* Atlaanta */}
                </Box>
                <Box component="p">
                  <Box component="span" fontWeight="500">
                    Ship Type:{dataDetailsState.vesselType}
                  </Box>{" "}
                  {/* 9563706 */}
                </Box>
                <Box component="p">
                  <Box component="span" fontWeight="500">
                    Classification:
                  </Box>{" "}
                  {/* V2FLB */}
                </Box>
                <Box component="p">
                  <Box component="span" fontWeight="500">
                    {" "}
                    Status:{dataDetailsState.vesselStatus}
                  </Box>{" "}
                  {/* BBC Chartering & Logistic GmbH */}
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid  className="hidediv" item xs={12} md={4} alignItems="stretch">
            <Box
              display="flex"
              bgcolor="#fff"
              px={4}
              py={2}
              height={1}
              className={clsx(classes.infoBox, classes.text2)}
            >
              <Box width={0.5}>
                <Box component="p" fontWeight="500" className={classes.text1}>
                  Contract :
                </Box>
                <Box display="flex">
                  <Box>
                    <PublishIcon className={commonClasses.cursorPointer} />
                  </Box>
                  <Box pl={2}>
                    <Box component="p" mt={0}>
                      Upload New Contract
                    </Box>
                    <Box component="p">View LO Chart</Box>
                    <Box component="p">Previous LO Chart </Box>
                  </Box>
                </Box>
              </Box>
              <Box width={0.5}>
                <Box
                  display="flex"
                  justifyContent="center"
                  height={1}
                  alignItems="center"
                >
                  <Box component="p">02-09-2020 </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12}>
            {/*
            <CustomerContractDetails rows={BreadcrumbList} dataOfEquipement = {dataOfEquipement}
        
        />*/}
          </Grid>
          </React.Fragment>

        ) : ""
      }
          
        </Grid>
      </Box>
    </div>
  );
}
